import type { KeyDownReactiveMap } from "../../../rx/reactive_map/useKeyDownReactiveMap"
import getSetEngineWeakMapFactory from "./getSetEngineWeakMapFactory"

export const [getEngineKeyDownReactiveMap, setEngineKeyDownReactiveMap] = getSetEngineWeakMapFactory<KeyDownReactiveMap>()
